export default "__VITE_ASSET__TXrX7ZDd__"